import moment from "moment";

/**
 * Shared bits for the Programmes list and a programme's detail page.
 * A list item is the member's programme entry: { title, start_date, program_length_type,
 * total_points_earned, _id: <the programme: program_slug, program_images, no_of_weeks…> }.
 */

const ENTITIES = { "&nbsp;": " ", "&amp;": "&", "&lt;": "<", "&gt;": ">", "&quot;": '"', "&#39;": "'" };

/** Plain text of an HTML string (works without a browser DOM). */
export const htmlText = (html) =>
  String(html || "")
    .replace(/<br\s*\/?>/gi, " ")
    .replace(/<\/(p|div|li|h[1-6])>/gi, " ")
    .replace(/<[^>]*>/g, "")
    .replace(/&[a-z#0-9]+;/gi, (e) => ENTITIES[e.toLowerCase()] || " ")
    .replace(/\s+/g, " ")
    .trim();

/**
 * The admin's programmes text (CMS HTML, e.g. "<h1>Programmes</h1><p>Welcome…</p>") →
 * { title: first heading or null, text: the rest as plain text }.
 */
export const splitIntro = (html) => {
  const source = String(html || "");
  const heading = source.match(/<h[1-6][^>]*>([\s\S]*?)<\/h[1-6]>/i);
  return {
    title: heading ? htmlText(heading[1]) || null : null,
    text: htmlText(heading ? source.replace(heading[0], "") : source),
  };
};

export const isLimited = (item) =>
  (item?.program_length_type || item?._id?.program_length_type) === "limited";

/** A limited programme opens only after the member picks a start date. */
export const canOpenCalendar = (item) => !(isLimited(item) && !item?.start_date);

/** "Limited" / "Ongoing" (the length in weeks is not shown). */
export const lengthLabel = (item) => (isLimited(item) ? "Limited" : "Ongoing");

export const formatDay = (date) => (date ? moment(date).format("D MMM YYYY") : "");
// The detail page's "Started On" / "Expire On" keep the old formats: 26-10-2026 / 2027-01-04.
export const formatStartedOn = (date) => (date ? moment(date).format("DD-MM-YYYY") : "N/A");
export const formatExpireOn = (date) => (date ? moment(date).format("YYYY-MM-DD") : "N/A");

/** End of a limited programme: start date + its weeks. */
export const endDate = (item, weeks = item?._id?.no_of_weeks) =>
  isLimited(item) && item?.start_date && weeks
    ? moment(item.start_date).add(weeks, "weeks").toDate()
    : null;

export const coinsLabel = (count) => {
  const n = Number(count) || 0;
  return `${n} coin${n === 1 ? "" : "s"} earned`;
};
